import React from "react";
export const Link = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    href,
    target = "_self",
    rel,
    linkText,
    className,
    internalLink = false
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "fw-500 underline external-link ".concat(className || ""),
    href: href,
    target: target,
    rel: rel,
    ref: ref
  }, /*#__PURE__*/React.createElement("span", null, linkText), !internalLink && /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-arrow-up-right-from-square icon-18"
  }));
});